"use client"
import { useNavigate } from "react-router-dom"
import "../styles/Welcome.css"

function Welcome() {
  const navigate = useNavigate()

  const handleCreateAccount = () => {
    navigate("/register")
  }

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <h1>Welcome to PopX</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,</p>
      </div>
      <div className="welcome-actions">
        <button className="create-account-btn" onClick={handleCreateAccount}>
          Create Account
        </button>
        <button className="login-btn" onClick={() => navigate("/login")}>
          Already Registered? Login
        </button>
      </div>
    </div>
  )
}

export default Welcome

